<ion-app>
  <!-- ! Etiqueta de tiempo -->
  <ng-container *ngIf="'Miscellaneous.time-label.visible' | translate">
    <div
      class="badge-label"
      [ngClass]="{ 'badge-label-maxtop': isMinWidthDesktop }"
    >
      {{ currentTime$ | async }}

      <ng-container
        *ngIf="'Miscellaneous.time-label.version-visible' | translate"
      >
        {{ versionApp }}
      </ng-container>
    </div>
  </ng-container>

  <ion-content color="gray" forceOverscroll="false">
    <div class="getm-app-content">
      <div
        class="content-app"
        [ngClass]="{'max-ion-page': isMinWidthDesktop}"
      >
        <ng-container *ngIf="menu">
          <hamburger-menu
            [disabled]="!menuDisabled"
            [version]="version"
          ></hamburger-menu>
        </ng-container>

        <ion-router-outlet id="main-content"></ion-router-outlet>
      </div>
    </div>
  </ion-content>
</ion-app>
